import { render } from "./BoardInspectorLegend.vue?vue&type=template&id=e12a35c8"
import script from "./BoardInspectorLegend.vue?vue&type=script&lang=js"
export * from "./BoardInspectorLegend.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__